module.exports = __webpack_public_path__ + "static/media/searchIcon.72b266c8.svg";